import './projectSection.scss';

import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { useState } from 'react';
import { Button } from '../../components';
import { Swiper, SwiperSlide } from 'swiper/react';
import ProjectImage1 from '../../images/project-1.png';
import ProjectImage2 from '../../images/project-2.png';
import ProjectImage3 from '../../images/project-3.png';
import { Navigation, Pagination } from 'swiper/modules';
import { TestimonialSection } from '../testimonial-section/TestimonialSection';
import useIsMobile from '../../utils/useMobile';

const ARROW_ICON = () => (
  <svg width="28" height="16" viewBox="0 0 28 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M27.2071 8.70711C27.5976 8.31658 27.5976 7.68342 27.2071 7.29289L20.8431 0.928932C20.4526 0.538408 19.8195 0.538408 19.4289 0.928932C19.0384 1.31946 19.0384 1.95262 19.4289 2.34315L25.0858 8L19.4289 13.6569C19.0384 14.0474 19.0384 14.6805 19.4289 15.0711C19.8195 15.4616 20.4526 15.4616 20.8431 15.0711L27.2071 8.70711ZM0 9H26.5V7H0V9Z"
      fill="#182433"
    />
  </svg>
);

export const ProjectSection = () => {
  const isMobile = useIsMobile();
  const [swiper, setSwiperRef] = useState<any>(null);

  const projects: Array<{ image: string; name: string; displayText: string; alt: string }> = [
    {
      image: ProjectImage1,
      name: 'Carpentry',
      displayText: 'Carpentry & Roofing',
      alt: 'Carpentry & Roofing Project',
    },
    {
      image: ProjectImage2,
      name: 'Closet',
      displayText: 'Closet Organizer Installation',
      alt: 'Closet Organizer Installation Project',
    },
    {
      image: ProjectImage3,
      name: 'Electrical',
      displayText: 'Electrical System Upgrade',
      alt: 'Electrical System Upgrade Project',
    },
  ];

  return (
    <div className={'projects'} id={'projects'}>
      <div className="projects__heading">
        <span id={'section-heading'}>Recent Projects</span>
      </div>
      <div className={'projects__top'}>
        <div className={'projects__top__left'}>
          <h1>View Projects We’ve Recently Worked On</h1>
        </div>
        <div className={'projects__top__right'}>
          <p>
            Discover some of the recent projects we've successfully completed. Our team is dedicated to
            delivering high-quality results for a wide range of home improvement and repair tasks.
          </p>
        </div>
        <Button text="See More" type={'primary'} />
      </div>
      <div className="projects__black-container"></div>
      <div className={'projects__bottom__service'}>
        {isMobile ? (
          <>
            <Swiper
              onSwiper={setSwiperRef}
              slidesPerView={'auto'}
              centeredSlides={false}
              spaceBetween={30}
              pagination={{
                type: undefined,
              }}
              navigation={false}
              modules={[Pagination, Navigation]}
              className="mySwiper"
            >
              {projects.map((data, index) => (
                <SwiperSlide key={index}>
                  <div key={index} className={'projects__bottom__service__item'}>
                    <h2>
                      <strong>{data.displayText}</strong>
                    </h2>
                    <div style={{ height: 30 }} />
                    <img src={data.image} alt={data.alt} style={{ width: '100%' }} width={'100%'} />
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
            <div className={'slide-navigation'}>
              <div className={'slide-navigation_option'} onClick={() => swiper?.slidePrev()}>
                <ARROW_ICON />
                <span>Prev</span>
              </div>
              <div className={'slide-navigation_option'} onClick={() => swiper?.slideNext()}>
                <span>Next</span>
                <ARROW_ICON />
              </div>
            </div>
          </>
        ) : (
          projects.map((data, index) => (
            <div key={index} className={'projects__bottom__service__item'}>
              <img src={data.image} alt={data.alt} />
              <div style={{ height: 30 }} />
              {/* <span>
                <strong>{data.displayText}</strong>
              </span> */}
            </div>
          ))
        )}
      </div>
      <TestimonialSection />
    </div>
  );
};
